import React from 'react';
import { Spin } from 'antd';

export default () => (
  <div style={{ height: '60vh' }} className="gx-w-100 gx-d-flex gx-justify-content-center gx-align-items-center">
    <Spin />
  </div>
);
